// Show dialog to user
import React from "react";

// Show dialogs for data input in profile building process
export default function Dialog(props) {
  // Render div
  return (
    <div
      className={`fixed flex items-center justify-center z-20 top-0 left-0 w-full h-full overflow-hidden ${
        props.show ? "" : "hidden"
      }`}
    >
      {/* Add backdrop */}
      <div className={`absolute opacity-20 bg-black-1 w-full h-full`}></div>

      {/* Render the content */}
      <div
        className={`relative w-full bg-white-1 shadow-md w-5/6 sm:w-3/5 md:w-2/3 lg:w-2/6 p-8 rounded-md box-border `}
      >
        <div className={`flex justify-between `}>
          {/* Add Title */}
          <div className={`font-semibold text-base md:text-2xl`}>
            {props.title}
          </div>
        </div>

        {/* Render childern */}
        <div className={`mt-5`}>{props.children}</div>
      </div>
    </div>
  );
}
